import LazyLoad, { ILazyLoadInstance } from 'vanilla-lazyload'

export let lazyLoadInstance: ILazyLoadInstance | null = null
// Only initialize it one time for the entire application
if (process.browser && !lazyLoadInstance) {
  lazyLoadInstance = new LazyLoad()
}
